module.exports = __webpack_public_path__ + "static/media/regular-icon.435b4702.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/regular-icon.svg
// module id = 1068
// module chunks = 0